import { Container, Box, Typography, Card, Grid, CardContent, Divider } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import React from 'react';
import { PagePlaceholder } from '../page-placeholder/PagePlaceholder';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles({
    root: {
        width: '100%',
        paddingLeft: 0,
        paddingRight: 0
    },
    tableWrapper: {
        maxHeight: 600,
        overflow: 'auto',
    },
    summaryCard: {
        backgroundColor: "#fafafa",
        marginTop: "30px"
    },
    cardRoot: {
        backgroundColor: "#fafafa",
    },
    tableRow: {
        backgroundColor: "white"
    }
});

export default function OrderManagerTable({ rows, ...props }) {
    const [t, i18n] = useTranslation()
    const classes = useStyles();
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);

    const columns = [
        { id: 'ProductId', label: t('order-manager.product'), minWidth: 170 },
        {
            id: 'Quantity', label: t('order-manager.quantity'), minWidth: 100, align: 'right',
        },
        {
            id: 'RejectionReasonId', label: t('order-manager.reason'), minWidth: 100, align: 'right',
        },
        {
            id: 'TotalNetPrice', label: t('order-manager.price'), minWidth: 100, align: 'right',
            // format: value => value.toLocaleString(),  
        },
        {
            id: 'TotalDiscount', label: t('order-manager.discount'), minWidth: 100, align: 'right',
            // format: value => value.toFixed(2),
        },
        {
            id: 'TotalPrice', label: t('order-manager.net-price'), minWidth: 100, align: 'right',
        },
    ];

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = event => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    if (!rows) {
        return null
    }

    const totalQuantity = rows.reduce((prevValue, currentItem) => prevValue + currentItem.Quantity, 0);
    const totalDiscount = rows.reduce((prevValue, currentItem) => prevValue + currentItem.TotalDiscount, 0);
    const totalPrice = rows.reduce((prevValue, currentItem) => prevValue + currentItem.TotalNetPrice, 0);
    const taxPrice = 2.25;
    const grossPrice = rows.reduce((prevValue, currentItem) => prevValue + currentItem.TotalPrice, 0);

    return (
        <Container maxWidth="false" className={classes.root}>
            <Card className={classes.cardRoot}>
                <CardContent>
                    <Box className={classes.tableWrapper}>
                        {
                            rows ?
                                <Table stickyHeader aria-label="sticky table">
                                    <TableHead>
                                        <TableRow>
                                            {columns.map(column => (
                                                <TableCell
                                                    key={column.id}
                                                    align={column.align}
                                                    style={{ minWidth: column.minWidth }}
                                                >
                                                    {column.label}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(row => {
                                            return (
                                                //Custom rows
                                                <TableRow hover role="checkbox" tabIndex={-1} key={row.code} className={classes.tableRow}>
                                                    {columns.map(column => {
                                                        const value = row[column.id];
                                                        return (
                                                            <TableCell key={column.id} align={column.align}>
                                                                <Typography variant="body1">{column.format && typeof value === 'number' ? column.format(value) : value}</Typography>
                                                            </TableCell>
                                                        );
                                                    })}
                                                </TableRow>
                                            );
                                        })}
                                    </TableBody>
                                </Table> :
                                <PagePlaceholder text={props.emptyPlaceholder} />
                        }
                    </Box>
                    {
                        rows ?
                            <TablePagination
                                rowsPerPageOptions={[10, 25, 100]}
                                component="div"
                                count={rows.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                backIconButtonProps={{
                                    'aria-label': 'previous page',
                                }}
                                nextIconButtonProps={{
                                    'aria-label': 'next page',
                                }}
                                onChangePage={handleChangePage}
                                onChangeRowsPerPage={handleChangeRowsPerPage}
                            />
                            : null
                    }
                </CardContent>
            </Card>

            {
                rows ?
                    <Card className={classes.summaryCard}>
                        <CardContent>
                            <Grid container spacing={1} justify="flex-end" alignItems="baseline">
                                {
                                    [
                                        {
                                            title: t('order-manager.physical-cases'),
                                            value: totalQuantity
                                        },
                                        {
                                            title: t('order-manager.subtotal'),
                                            value: totalPrice.toFixed(2)
                                        },
                                        {
                                            title: t('order-manager.total-disount'),
                                            value: totalDiscount.toFixed(2)
                                        },
                                        {
                                            title: t('order-manager.total-incl-gst', { taxPrice: taxPrice }),
                                            value: grossPrice.toFixed(2)
                                        }
                                    ].map(item => {
                                        return (
                                            <Grid item xs={2} alignContent="flex-end">
                                                <Typography align="center" className={classes.itemTitle} variant="body1">
                                                    {item.value}
                                                </Typography>
                                                <Divider />
                                                <Typography align="center" variant="subtitle2">
                                                    {item.title}
                                                </Typography>
                                            </Grid>
                                        )
                                    })
                                }
                            </Grid>
                        </CardContent>
                    </Card>
                    : null
            }
        </Container>
    );
}